import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, GraduationCapIcon, SparklesIcon, CheckIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function QueIncluye() {
  return <section id="que-incluye" className="py-20 md:py-28 bg-gray-50" data-id="element-147">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-148">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-16" data-id="element-149">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-navy-900 mb-4" data-id="element-150">
            ¿Qué incluye el <span className="text-gold-600" data-id="element-151">Mega Pack</span>?
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-152">
            Todo el material está organizado por niveles para que encuentres lo
            que necesitas en segundos.
          </p>
        </motion.div>

        {/* Three Columns */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-153">
          {/* Column A - Primaria */}
          <motion.div variants={itemVariants} className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100" data-id="element-154">
            <div className="flex items-center gap-3 mb-6" data-id="element-155">
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center" data-id="element-156">
                <BookOpenIcon className="h-6 w-6 text-blue-600" data-id="element-157" />
              </div>
              <div data-id="element-158">
                <h3 className="font-bold text-xl text-navy-900" data-id="element-159">
                  Nivel Primaria
                </h3>
                <p className="text-sm text-gray-500" data-id="element-160">Tomos 1 al 7</p>
              </div>
            </div>
            <ul className="space-y-4" data-id="element-161">
              <li className="flex items-start gap-3" data-id="element-162">
                <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" data-id="element-163" />
                <span className="text-gray-700" data-id="element-164">
                  Alfabetización inicial y lectoescritura
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-165">
                <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" data-id="element-166" />
                <span className="text-gray-700" data-id="element-167">
                  Secuencias didácticas de comprensión lectora
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-168">
                <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" data-id="element-169" />
                <span className="text-gray-700" data-id="element-170">
                  Talleres de escritura creativa para niños
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-171">
                <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" data-id="element-172" />
                <span className="text-gray-700" data-id="element-173">
                  Evaluaciones adaptadas por grado
                </span>
              </li>
            </ul>
          </motion.div>

          {/* Column B - Secundaria */}
          <motion.div variants={itemVariants} className="bg-white rounded-2xl p-8 shadow-xl border-2 border-gold-500 relative" data-id="element-174">
            {/* Badge */}
            <div className="absolute -top-4 left-1/2 -translate-x-1/2" data-id="element-175">
              <span className="bg-gradient-to-r from-gold-500 to-gold-600 text-navy-900 text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-wide shadow-lg" data-id="element-176">
                Más Buscado
              </span>
            </div>
            <div className="flex items-center gap-3 mb-6 mt-2" data-id="element-177">
              <div className="w-12 h-12 bg-gold-100 rounded-xl flex items-center justify-center" data-id="element-178">
                <GraduationCapIcon className="h-6 w-6 text-gold-600" data-id="element-179" />
              </div>
              <div data-id="element-180">
                <h3 className="font-bold text-xl text-navy-900" data-id="element-181">
                  Nivel Secundaria
                </h3>
                <p className="text-sm text-gray-500" data-id="element-182">Tomos 8 al 13</p>
              </div>
            </div>
            <ul className="space-y-4" data-id="element-183">
              <li className="flex items-start gap-3" data-id="element-184">
                <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" data-id="element-185" />
                <span className="text-gray-700" data-id="element-186">
                  Análisis literario de clásicos y contemporáneos
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-187">
                <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" data-id="element-188" />
                <span className="text-gray-700" data-id="element-189">
                  Guías de gramática, sintaxis y ortografía
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-190">
                <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" data-id="element-191" />
                <span className="text-gray-700" data-id="element-192">
                  Proyectos de debate y argumentación lógica
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-193">
                <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" data-id="element-194" />
                <span className="text-gray-700" data-id="element-195">
                  Planificaciones anuales completas
                </span>
              </li>
            </ul>
          </motion.div>

          {/* Column C - Bonos */}
          <motion.div variants={itemVariants} className="bg-gradient-to-br from-navy-800 to-navy-900 rounded-2xl p-8 shadow-lg md:col-span-2 lg:col-span-1" data-id="element-196">
            <div className="flex items-center gap-3 mb-6" data-id="element-197">
              <div className="w-12 h-12 bg-gold-500/20 rounded-xl flex items-center justify-center" data-id="element-198">
                <SparklesIcon className="h-6 w-6 text-gold-400" data-id="element-199" />
              </div>
              <div data-id="element-200">
                <h3 className="font-bold text-xl text-white" data-id="element-201">
                  Bonos Exclusivos
                </h3>
                <p className="text-sm text-gray-400" data-id="element-202">Material de Apoyo</p>
              </div>
            </div>
            <div className="space-y-4" data-id="element-203">
              {/* Bono 1 - Plan de Clases Express */}
              <div className="bg-white/10 rounded-xl p-4 backdrop-blur-sm" data-id="element-204">
                <img src="https://cdn.magicpatterns.com/uploads/tE675GMuz87mRMZJ8pFoLU/dbe2f9ce-ae97-4e04-87a1-a999a5eb31cb.png" alt="Bono 1 - Plan de Clases Express 10 min" className="w-full h-48 object-contain mb-2" data-id="element-205" />
                <p className="text-white text-sm font-medium text-center" data-id="element-206">
                  Plan de clases express 10 min
                </p>
              </div>
              {/* Bono 2 - Evaluaciones */}
              <div className="bg-white/10 rounded-xl p-4 backdrop-blur-sm" data-id="element-207">
                <img src="https://cdn.magicpatterns.com/uploads/giktMVrAB8Q2NUrxQyPQKj/1b2ed691-e6af-4cfa-b3be-9cacbbefa07a.png" alt="Bono 2 - Evaluaciones listas sin estrés" className="w-full h-48 object-contain mb-2" data-id="element-208" />
                <p className="text-white text-sm font-medium text-center" data-id="element-209">
                  Evaluaciones listas sin estrés
                </p>
              </div>
              {/* Bono 3 - Consignas */}
              <div className="bg-white/10 rounded-xl p-4 backdrop-blur-sm" data-id="element-210">
                <img src="https://cdn.magicpatterns.com/uploads/23Z1Kh712aLdHsUQNLEzHh/2ca785d8-202f-4628-87a7-a1a3cfa6d7d9.png" alt="Bono 3 - 45 disparadores listos para usar" className="w-full h-48 object-contain mb-2" data-id="element-211" />
                <p className="text-white text-sm font-medium text-center" data-id="element-212">
                  45 disparadores listos para usar
                </p>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}